import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import ListMiniCards from 'generic/ListMiniCards';
import PaginationMenu from 'components/generic/PaginationMenu';
import GridUserData from 'generic/GridUserData';
import SkeletonMiniCard from 'generic/SkeletonMiniCard';
import { useStores } from 'hooks/useStores';

import NoAdsMessage from './components/NoAdsMessage';
import { Wrapper } from './SearchResultStyles';

const SearchResult = observer(() => {
  const {
    advertsStore: { adverts, accounts, stars },
    findTrucksStore: { searchState, pagination },
    statusesStore: { getStatuses },
  } = useStores();

  useEffect(() => {
    getStatuses(accounts);
  }, [accounts]);

  const isLoading = searchState.isRequest;
  const isNoAds = !adverts.length;

  const renderSkeletons = () =>
    new Array(pagination.limit).fill(0).map((item, i) => <SkeletonMiniCard key={i} item />);

  return (
    <Wrapper id="search-result">
      {!isNoAds && (
        <>
          <PaginationMenu position="top" pagination={pagination} />
          <ListMiniCards
            adverts={adverts}
            accounts={accounts}
            stars={stars}
            location="search"
            loading={isLoading}
          />
          <PaginationMenu pagination={pagination} showStep />
        </>
      )}
      {isNoAds && !isLoading && <NoAdsMessage />}
      {isNoAds && isLoading && renderSkeletons()}
      <GridUserData />
    </Wrapper>
  );
});

export default SearchResult;
